import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import moment from "moment";
import { Dimmer } from "../../spinner";
import { Mensaje } from "../../mensajes2";
import { cmes, diasMes, validaSoloNumero } from "../../../util/varios";
import CatalogoComercio from "../../../catalogos/catalogoComercio";

export const ImpLicenciasLicores = (props) => {
  const op = require("../../../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const anioactu = parseInt(localStorage.getItem("anioactu"));
  const espiritu = localStorage.getItem("espiritu");
  const siguienteAnio = (anioactu || new Date().getFullYear()) + 1;
  const fechaActual = new Date().toISOString().split("T")[0];
  const fechaVenci = `${siguienteAnio}-12-31`;
  const [loading, setLoading] = useState(false);
  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [poseeLic, setPoseeLic] = useState(false);
  const [tipoLicencias, setTiposLicencias] = useState([]);
  const [fechaEmision, setFechaEmision] = useState(fechaActual);
  const [fechaVencimiento, setFechaVencimiento] = useState(fechaVenci);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [body, setBody] = useState({
    tipoLicencia: "",
    codigo: "",
    licencia: "",
    numLicenciaActual: "",
    numLicenciaNueva: "",
    fechaInscripcion: "",
    rif: "",
    denominacionComercial: "",
    direccion: "",
    numSectorCatastral: "",
    numCuenta: "",
    indoleExpendio: "",
    rifProp: "",
    nomProp: "",
    direcProp: "",
  });
  const buscarComercio = async (idComercio) => {
    try {
      setLoading(true);
      const campos = `
        c.codigocatastral, c.fechainscripcion, c.licencialicores,
        c.rif, c.cuenta, c.nombre,
        c.direccion, c.convenio, c.idcomercio,
        c.fechainscripcion,
        p.cedula as cedula_repre, 
        p.direccion as direccion_repre, 
        (p.nombres || ' ' || p.apellidos ) AS nombre_repre,
        json_agg(
          json_build_object(
            'licencia', TRIM(tc.licencia),
            'descripcion', TRIM(t.descripcion),
            'indole', (t.descripcion || ' Desde ' || to_char(t.horaabierto, 'HH12:MI AM') || ' Hasta ' || to_char(t.horacerrado, 'HH12:MI AM'))
          )
        ) AS detalle_licencias
      `;
      const tabla = `
      comercio c 
      inner join persona p on c.reprelegal = p.cedula
      inner join tipoexpendioxcomercio tc on tc.idcomercio = c.idcomercio
      inner join tipoexpendio t on t.idtipoexpendio = tc.idtipoexpendio
      `;
      const nomid = "c.idcomercio";
      const condic = `c.idcomercio = ${idComercio}
      GROUP BY 
    c.codigocatastral, c.fechainscripcion, c.licencialicores, c.rif,
    c.cuenta, c.nombre, c.direccion, c.convenio, c.idcomercio,
    p.cedula, p.direccion, p.nombres, p.apellidos`;
      const endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${idComercio}&nomtab=${tabla}&nomid=${nomid}&condic=${condic}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data.length > 0) {
        const data = response.data[0];
        let indole = "";
        data.detalle_licencias.forEach((e) => {
          indole += `-- ${e.indole} --\n`;
        });
        const nuevosTipos = data.detalle_licencias.map((e) => ({
          value: e.licencia,
          label: `${e.descripcion} (${e.licencia})`,
        }));
        setTiposLicencias(nuevosTipos);
        setBody((prev) => ({
          ...prev,
          ...data,
          tipoLicencia: data.detalle_licencias[0].licencia,
          numSectorCatastral: data.codigocatastral,
          fechaInscripcion: moment
            .utc(data.fechainscripcion)
            .format("DD/MM/YYYY"),
          codigo: data.idcomercio,
          numCuenta: data.cuenta,
          denominacionComercial: data.nombre,
          direccion: data.direccion,
          rifProp: data.cedula_repre,
          nomProp: data.nombre_repre,
          direcProp: data.direccion_repre,
          indoleExpendio: indole,
          numLicenciaActual: data.licencialicores,
        }));
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Informacion",
          texto: "Comercio no Encontrado",
          icono: "informacion",
        });
        setBody({
          codigo: "",
          licencia: "",
          numLicenciaActual: "",
          numLicenciaNueva: "",
          fechaInscripcion: "",
          rif: "",
          denominacionComercial: "",
          direccion: "",
          numSectorCatastral: "",
          numCuenta: "",
          indoleExpendio: "",
          rifProp: "",
          nomProp: "",
          direcProp: "",
        });
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response
          ? error.response.data.message
          : "Error al Buscar el Comercio",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const buscarUltimoNumLicencia = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/licores/ultimonumber?efiscal=${anioactu}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data) {
        const { nrolicencia } = response.data;
        const num = parseInt(nrolicencia) + 1;
        setBody((prev) => ({
          ...prev,
          numLicenciaNueva: num,
        }));
      } else {
        setBody((prev) => ({
          ...prev,
          numLicenciaNueva: 1,
        }));
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response
          ? error.response.data.message
          : "Error al Buscar Ultimo Numero de Licencia",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const buscarLicenciaComercio = async (idComercio) => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/licores/ultimalicencia?id=${idComercio}&efiscal=${anioactu}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data) {
        setPoseeLic(true);
      } else {
        buscarUltimoNumLicencia();
        setPoseeLic(false);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response
          ? error.response.data.message
          : "Error al Buscar la Licencia del Comercio",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const validarContribuyente = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        buscarComercio(event.target.value);
        buscarLicenciaComercio(event.target.value);
      }
    }
  };
  const handleFechaVencimientoBlur = (event) => {
    const { value } = event.target;
    if (value && fechaEmision) {
      const fechaVencimientoFormat = new Date(value);
      const fechaEmisionDate = new Date(fechaEmision);
      const fechaActual = new Date();
      const añoActual = fechaActual.getFullYear();
      const añoSeleccionado = fechaVencimientoFormat.getFullYear();

      fechaVencimientoFormat.setHours(0, 0, 0, 0);
      fechaEmisionDate.setHours(0, 0, 0, 0);
      if (
        fechaVencimientoFormat >= fechaEmisionDate &&
        añoSeleccionado >= añoActual
      ) {
        setFechaVencimiento(value);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Informacion",
          texto:
            "La fecha de vencimiento no puede ser menor a la fecha de emisión ni al año actual",
          icono: "informacion",
        });
        setFechaVencimiento(fechaVenci);
      }
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBody((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const guardarLicencia = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/licores/insertlicencia`;
      const response = await axios.post(
        endpoint,
        {
          idComercio: body.codigo,
          numLicencia: body.numLicenciaNueva,
          anio: anioactu,
          fechaEmision: fechaEmision,
          fechaVence: fechaVencimiento,
          indole: body.tipoLicencia,
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: "Licencia Registrada Correctamente",
          icono: "exito",
        });
        generarReporteSegunMunicipio();
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response
          ? error.response.data.message
          : "Error al Guardar la Licencia",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const actualizarLicencia = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/licores/updatelicencia`;
      const response = await axios.post(
        endpoint,
        {
          nuevLicen: body.numLicenciaNueva,
          idComercio: body.codigo,
          fechaEmision: fechaEmision,
          fechaVence: fechaVencimiento,
          anio: anioactu,
          nrolicencia: body.numLicenciaActual,
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: "Licencia Actualizada Correctamente",
          icono: "exito",
        });
        generarReporteSegunMunicipio();
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response
          ? error.response.data.message
          : "Error al Actualizar la Licencia",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const imprimirReporte = async () => {
    try {
      if (!body.codigo) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "No se ha Seleccionado Ningún Comercio",
          icono: "error",
        });
        return;
      }
      setLoading(true);
      if (!poseeLic) {
        await guardarLicencia();
      } else {
        await actualizarLicencia();
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Imprimir el Reporte",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const generarReporteSegunMunicipio = () => {
    try {
      const fechaActualFormat = moment(fechaEmision);
      const dd = fechaActualFormat.format("DD");
      const mm = fechaActualFormat.format("MM");
      const aa = fechaActualFormat.format("YYYY");
      const nDias = diasMes(parseInt(mm), parseInt(aa));
      const nombrem = cmes(parseInt(mm));
      const sql = `${body.codigo}`;
      let reporte = "";
      switch (parseInt(espiritu)) {
        case 0: // Turen/Paez
          reporte = "LicenciaLicoresPaez";
          break;
        case 1: // Piritu
          reporte = "PatenteIndComPiritu";
          break;
        case 2: // Turen
          reporte = "LicenciaLicoresTuren";
          break;
        case 9: // Araure
          reporte = "LicenciaLicoresAraure";
          break;
        case 11: // Satrimsca
          reporte = "LicenciaLicoresSatrimsca";
          break;
        case 12: // Sro
          reporte = "LicenciaLicoresSro";
          break;
        case 14: // Unda/Chabasquen
          reporte = "LicenciaLicoresUnda";
          break;
        default:
          reporte = "LicenciaLicoresPaez";
      }
      const url = `${op.reportes}/rentaslicores?reporte=LicenciaLicores&ULTIMO=${nDias}&CONDICION=${sql}&DIA=${dd}&MES=${nombrem}&AÑO=${aa}&LICENCIA=${body.tipoLicencia}&aniovence=${aa}`;
      window.open(
        url,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Generar el Reporte",
        icono: "error",
      });
    } finally {
      blanquear();
    }
  };
  const blanquear = () => {
    setLoading(false);
    setPoseeLic(false);
    setTiposLicencias([]);
    setFechaEmision(fechaActual);
    setFechaVencimiento(fechaVenci);
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setBody({
      tipoLicencia: "",
      codigo: "",
      licencia: "",
      numLicenciaActual: "",
      numLicenciaNueva: "",
      fechaInscripcion: "",
      rif: "",
      denominacionComercial: "",
      direccion: "",
      numSectorCatastral: "",
      numCuenta: "",
      indoleExpendio: "",
      rifProp: "",
      nomProp: "",
      direcProp: "",
    });
    setMostrarCatalogo(false);
  };
  const salir = () => {
    props.setShow(false);
    props.setTabla();
  };
  useEffect(() => {
    if (fechaEmision) {
      const fechaEmisionFormat = new Date(fechaEmision);
      const añoEmision = fechaEmisionFormat.getFullYear();
      const mesEmision = fechaEmisionFormat.getMonth();
      const diaEmision = fechaEmisionFormat.getDate();
      const fechaVencimiento = new Date(
        añoEmision + 1,
        mesEmision,
        diaEmision + 1,
      );
      if (fechaVencimiento.getMonth() !== mesEmision) {
        fechaVencimiento.setDate(0);
      }
      const fechaVencimientoFormateada = fechaVencimiento
        .toISOString()
        .split("T")[0];
      if (fechaVencimiento !== fechaVencimientoFormateada) {
        setFechaVencimiento(fechaVencimientoFormateada);
      }
    }
  }, [fechaEmision]);
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onShow={() => {
        blanquear();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          Impresión de Licencias de Licores
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between">
          <div className="col-md-6 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Tipo de Licencia:
              </span>
              <select
                className="form-control text-uppercase"
                name="tipoLicencia"
                value={body.tipoLicencia}
                onChange={handleChange}
              >
                {tipoLicencias.map((opt, idx) => (
                  <option key={idx} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-3 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Nº de Licencia Actual:
              </span>
              <input
                type="text"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="numLicenActual"
                value={body.numLicenciaActual}
                disabled
              />
            </div>
          </div>
          <div className="col-md-3 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Nº de Nueva Licencia:
              </span>
              <input
                type="text"
                className="form-control text-uppercase text-right"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="numLicenNueva"
                value={body.numLicenciaNueva}
                disabled
              />
            </div>
          </div>
        </div>
        <fieldset className="row mb-2 border-azul row rounded mx-auto">
          <legend
            className="float-none w-auto fw-bold text-uppercase"
            style={{
              fontSize: "0.9rem",
            }}
          >
            Fechas
          </legend>
          <div className="d-flex justify-content-between">
            <div className="col-md-4 row mx-auto p-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Fecha de Emision:
                </span>
                <input
                  type="date"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="fechaEmision"
                  max={fechaActual}
                  value={fechaEmision}
                  onChange={(e) => {
                    const { value } = e.target;
                    setFechaEmision(value);
                  }}
                />
              </div>
            </div>
            <div className="col-md-4 row mx-auto p-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Fecha de Vencimiento:
                </span>
                <input
                  type="date"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="fechaVenci"
                  value={fechaVencimiento}
                  onChange={(e) => {
                    const { value } = e.target;
                    setFechaVencimiento(value);
                  }}
                  onBlur={handleFechaVencimientoBlur}
                />
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset className="row mb-2 border-azul row rounded mx-auto">
          <legend
            className="float-none w-auto fw-bold text-uppercase"
            style={{
              fontSize: "0.9rem",
            }}
          >
            Informacion
          </legend>
          <div className="d-flex justify-content-between">
            <div className="col-md-2 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Código:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="codigo"
                  value={body.codigo}
                  onKeyUp={validarContribuyente}
                  onChange={handleChange}
                />
                <button
                  onClick={() => setMostrarCatalogo(true)}
                  style={{ textAlign: "center", color: "white" }}
                  className="btn btn-sm btn-info"
                >
                  <i className="fas fa-search"></i>{" "}
                </button>
              </div>
            </div>
            <div className="col-md-2 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  RIF:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="rif"
                  disabled
                  value={body.rif}
                />
              </div>
            </div>
            <div className="col-md-8 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Denominación Comercial:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="denominacion"
                  disabled
                  value={body.denominacionComercial}
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="col-md-12 row my-auto py-2 px-0 mx-0">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Dirección:
                </span>
                <textarea
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  value={body.direccion}
                  disabled
                  style={{ height: 60 }}
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="col-md-6 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Sector Catastral N°:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  value={body.numSectorCatastral}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-6 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  N° de Cuenta:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  value={body.numCuenta}
                  disabled
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="col-md-12 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Índole de Expendio:
                </span>
                <textarea
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  value={body.indoleExpendio}
                  style={{ height: 60 }}
                  rows="3"
                  disabled
                />
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset className="row mb-2 border-azul row rounded mx-auto">
          <legend
            className="float-none w-auto fw-bold text-uppercase"
            style={{
              fontSize: "0.9rem",
            }}
          >
            Propietario
          </legend>
          <div className="d-flex justify-content-between">
            <div className="col-md-4 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Cédula/RIF Propietario:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  disabled
                  value={body.rifProp}
                />
              </div>
            </div>
            <div className="col-md-8 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Nombre Propietario:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  disabled
                  value={body.nomProp}
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="col-md-12 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Direccion Propietario:
                </span>
                <textarea
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  disabled
                  value={body.direcProp}
                  style={{ height: 60 }}
                />
              </div>
            </div>
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => imprimirReporte()}
          className="btn-sm rounded-pill btn btn-primary col-md-2"
        >
          <i className="fas fa-print"></i> Imprimir
        </button>
        <button
          onClick={() => blanquear()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fas fa-window-close"></i> Cancelar
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-sign-out"></i> Salir
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
      <Dimmer active={loading} inverted />
      <CatalogoComercio
        show={mostrarCatalogo}
        onHideCancelaCatCom={() => setMostrarCatalogo(false)}
        onHideAceptaCatCom={(idCome) => {
          buscarComercio(idCome);
          buscarLicenciaComercio(idCome);
        }}
      />
    </Modal>
  );
};
